export default [
  {
    path: '/fraud-detection/config',
    name: 'fraud-detection-config',
    component: () => import('@/views/fraud-detection/FraudConfig.vue'),
    meta: {
      resource: 'lotto',
      action: ['read'],
      pageTitle: 'ตั้งค่าระบบตรวจจับการปั้ม',
      breadcrumb: [
        { text: 'หน้าแรก', to: '/' },
        { text: 'ตั้งค่าระบบตรวจจับการปั้ม', active: true },
      ],
    },
  },
  {
    path: '/fraud-detection/activities',
    name: 'fraud-detection-activities',
    component: () => import('@/views/fraud-detection/FraudActivities.vue'),
    meta: {
      resource: 'lotto',
      action: ['read'],
      pageTitle: 'รายการกิจกรรมน่าสงสัย',
      breadcrumb: [
        { text: 'หน้าแรก', to: '/' },
        { text: 'รายการกิจกรรมน่าสงสัย', active: true },
      ],
    },
  },
]
